'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2017/2/25.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _designerList = require('redux/modules/designerList');

var designerListAction = _interopRequireWildcard(_designerList);

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesignerList = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var location = _ref.location;

    var promises = [];
    var query = location.query;
    var filter = '';
    var page = null;
    var orderItem = '';
    var direction = '';
    if (query.type) {
      filter = { type: query.type };
    }
    if (query.masterId) {
      filter = (0, _extends3.default)({}, filter, { masterId: query.masterId });
    }
    if (query.productType) {
      filter = (0, _extends3.default)({}, filter, { productType: query.productType });
    }
    if (query.shop) {
      filter = (0, _extends3.default)({}, filter, { shopId: query.shop });
    }
    if (query.author) {
      filter = (0, _extends3.default)({}, filter, { authorId: query.author });
    }
    if (query.honorId) {
      filter = (0, _extends3.default)({}, filter, { honorId: query.honorId });
    }
    if (query.findValue) {
      filter = (0, _extends3.default)({}, filter, { FindValue: query.findValue });
    }
    if (query.isExperienceProduct) {
      filter = (0, _extends3.default)({}, filter, { isExperienceProduct: query.isExperienceProduct });
    }
    if (query.isExperienceGoods) {
      filter = (0, _extends3.default)({}, filter, { isExperienceGoods: query.isExperienceGoods });
    }
    if (query.page) {
      page = query.page;
    }
    if (query.orderBy) {
      orderItem = query.orderBy;
    }
    if (query.direction) {
      direction = query.direction;
    }
    promises.push(dispatch((0, _background.changeHeaderText)('大师')));
    promises.push(dispatch(designerListAction.load(filter, {
      orderItem: orderItem,
      direction: direction
    }, designerListAction.isLoaded(getState()), page)));
    /*
     if (!designerListAction.isFilterDataLoad(getState())) {
     promises.push(dispatch(designerListAction.loadFilterData('M004313')));
     } */
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.designerList.data,
    filterData: state.designerList.filterData,
    dataError: state.designerList.error
  };
}, (0, _extends3.default)({}, designerListAction, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DesignerList, _Component);

  function DesignerList() {
    (0, _classCallCheck3.default)(this, DesignerList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(DesignerList).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(DesignerList, [{
    key: 'onMasterItemClick',
    value: function onMasterItemClick(masterId) {
      var routerPush = this.props.routerPush;
      // console.log(masterId);

      if (routerPush && masterId) {
        // const query = {};
        // query.masterId = masterId;
        // routerPush({pathname: location.pathname, query: query});
        // routerPush('/designer/' + masterId);
        // window.open('http://www.craftschina.cn/designer/' + masterId);
      }
    }
  }, {
    key: 'onOrderItemClick',
    value: function onOrderItemClick(val) {
      var _props = this.props;
      var routerPush = _props.routerPush;
      var location = _props.location;

      switch (val) {
        case 'YataiMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043120000000000000000001') {
              var query = {};
              query.honorId = 'M0043120000000000000000001';
              routerPush({ pathname: location.pathname, query: query });
            }
          }
          break;
        case 'GuoMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043120000000000000000002') {
              var _query = {};
              _query.honorId = 'M0043120000000000000000002';
              routerPush({ pathname: location.pathname, query: _query });
            }
          }
          break;
        case 'HangYeMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043120000000000000000004') {
              var _query2 = {};
              _query2.honorId = 'M0043120000000000000000004';
              routerPush({ pathname: location.pathname, query: _query2 });
            }
          }
          break;
        case 'ShengMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043120000000000000000003') {
              var _query3 = {};
              _query3.honorId = 'M0043120000000000000000003';
              routerPush({ pathname: location.pathname, query: _query3 });
            }
          }
          break;
        case 'ShiMaster':
          if (routerPush) {
            if (location.query.honorId !== 'M0043129999999999999999999') {
              var _query4 = {};
              _query4.honorId = 'M0043129999999999999999999';
              routerPush({ pathname: location.pathname, query: _query4 });
            }
          }
          break;
        case 'zw':
          break;
        default:
          if (routerPush) {
            var _query5 = {};
            routerPush({ pathname: location.pathname, query: _query5 });
          }
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var _props2 = this.props;
      var routerPush = _props2.routerPush;
      var location = _props2.location;

      if (routerPush) {
        routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { page: page }) });
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(val) {
      var _props3 = this.props;
      var routerPush = _props3.routerPush;
      var location = _props3.location;

      if (routerPush) {
        var query = {};
        if (val) {
          query.findValue = val;
        }
        routerPush({ pathname: location.pathname, query: query });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var data = _props4.data;
      var location = _props4.location;
      // console.log(filterData); filterData
      /* let realFilterData = [];
       if (filterData && filterData.filterData instanceof Array) {
       realFilterData = filterData.filterData;
       } */

      var currentPage = 0;
      var carouselDiv = '';
      var greatMasterDiv = '';
      var designerFilterDiv = '';
      var totalPageNumber = 1;
      if (data) {
        var listOfGreatMaster = data.listOfGreatMaster;
        var listOfGreatMasterError = data.listOfGreatMasterError;
        var greatMasterFilterBar = data.greatMasterFilterBar;
        var greatMasterFilterBarError = data.greatMasterFilterBarError;
        var listOfGreatMasterRecordCount = data.listOfGreatMasterRecordCount;
        var listOfGreatMasterPagesize = data.listOfGreatMasterPagesize;
        var carouselOfGreatMaster = data.carouselOfGreatMaster;
        var carouselOfGreatMasterError = data.carouselOfGreatMasterError;

        if (carouselOfGreatMasterError) {
          carouselDiv = carouselOfGreatMasterError;
        } else if (carouselOfGreatMaster instanceof Array) {
          carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'productList', images: carouselOfGreatMaster });
        }

        if (greatMasterFilterBarError) {
          designerFilterDiv = carouselOfGreatMasterError;
        } else {
          designerFilterDiv = _react2.default.createElement(_components.DesignerFilterBar, { onItemClick: this.onMasterItemClick.bind(this), data: greatMasterFilterBar });
        }
        if (listOfGreatMasterError) {
          greatMasterDiv = _react2.default.createElement(
            'div',
            null,
            listOfGreatMasterError
          );
        } else {
          if (location.query && !isNaN(parseInt(location.query.page, 10))) {
            currentPage = parseInt(location.query.page, 10);
          }
          greatMasterDiv = _react2.default.createElement(
            'ul',
            { style: { width: '100%' } },
            listOfGreatMaster instanceof Array ? listOfGreatMaster.map(function (item, index) {
              return _react2.default.createElement(_components.ProductInfo, { key: item.id, index: index, product: item,
                defaultImg: 'http://tupian.goeasy.cn:9999/yipinwang/master.jpg', isDesigner: !!1 });
            }) : _react2.default.createElement(
              'li',
              { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
              '未搜索到相关大师'
            )
          );
        }
        totalPageNumber = parseInt(listOfGreatMasterRecordCount / listOfGreatMasterPagesize, 10);
        if (listOfGreatMasterRecordCount % listOfGreatMasterPagesize > 0) {
          ++totalPageNumber;
        }
      }

      var orderArray = [{ id: '', text: '全部大师' }, { id: 'YataiMaster', text: '亚太大师', honorId: 'M0043120000000000000000001' }, { id: 'GuoMaster', text: '国大师', honorId: 'M0043120000000000000000002' }, { id: 'HangYeMaster', text: '行业大师', honorId: 'M0043120000000000000000004' }, { id: 'ShengMaster', text: '省大师', honorId: 'M0043120000000000000000003' }, { id: 'ShiMaster', text: '市大师', honorId: 'M0043129999999999999999999' }];
      var middleImages = ['http://tupian.goeasy.cn:9999/yipinwang/third/ds_icon_b.png', 'http://tupian.goeasy.cn:9999/yipinwang/third/ds_icon_a.png'];
      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.HomePageSearchBar, { placeholderTexts: '请输入大师名或店铺名', onSearch: this.onSearch.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          null,
          designerFilterDiv
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.ListPageMiddleFlip, { data: middleImages }),
        _react2.default.createElement(_components.HomePageOrderBar, { texts: orderArray, location: location, onItemClick: this.onOrderItemClick.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        greatMasterDiv,
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return DesignerList;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object,
  params: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  data: _react.PropTypes.object,
  filterData: _react.PropTypes.object,
  load: _react.PropTypes.func,
  routerPush: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = DesignerList;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/DesignerList/DesignerList.js
 ** module id = 1461
 ** module chunks = 0
 **/